// Stripe

// Live
export const stripePublishableKey = 'pk_live_1UIX7thfxVW34ApEb1tEe0vM003S9ZFDtE'

// // Testing
// export const stripePublishableKey = "pk_test_C1bLJHJRBCvD0TyaR9IfNmZS00ZUWF5xx9"
